/** `guests` — the guest list: who gets in, with which pass. */
import { z } from "zod";
import { defineCollection, field } from "../define.ts";

export const guests = defineCollection({
  key: "guests",
  labelKey: "collections.guests",
  icon: "ticket",
  sheetTab: "Guests",
  dedupFields: ["name"],
  sort: [{ field: "name" }],
  split: "people",
  chatHint:
    "Guest list for the gig: name, pass type (guest/VIP/AAA/photo), who requested them, status. " +
    "'Put X +1 on the list' creates a row here.",
  fields: {
    name: field({
      type: z.string().min(1),
      tier: "hot",
      pii: "crew",
      labelKey: "guests.name",
      sheet: { column: "Name" },
      description: "Guest's name (add '+1' rows separately or note plus-ones in notes).",
    }),
    pass_type: field({
      type: z.string().optional(),
      tier: "hot",
      pii: "crew",
      labelKey: "guests.pass_type",
      suggestedChips: ["guest", "VIP", "AAA", "photo", "aftershow"],
      sheet: { column: "Pass" },
      description: "guest | VIP | AAA | photo | aftershow — whatever the venue issues.",
    }),
    requested_by: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "guests.requested_by",
      sheet: { column: "Requested by" },
      description: "Who asked for this guest (artist, label, promoter…).",
    }),
    status: field({
      type: z.enum(["requested", "confirmed", "declined"]),
      tier: "hot",
      pii: "crew",
      labelKey: "guests.status",
      sheet: { column: "Status" },
      description: "requested | confirmed | declined.",
    }),
    notes: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "guests.notes",
      sheet: { column: "Notes" },
      description: "Plus-ones, pickup point, anything else.",
    }),
  },
});
